import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { CommonParamsType } from "constants/types/common";
import { PurchaseOrderParamsType } from "constants/types/purchaseOrder";
import { FC, useCallback } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import PurchaseOrderActions from "./components/PurchaseOrderActions/PurchaseOrderActions";
import PurchaseOrderTable from "./components/PurchaseOrderTable/PurchaseOrderTable";
import { PURCHASE_ORDER_PAGE_TITLE } from "./config";

const PurchaseOrderWebLayout: FC = () => {
  const {
    params,
    setParams,
    handlePageChange,
    handleLimitChange,
    handleSearch,
  } = useTableParams<PurchaseOrderParamsType>();

  const handleFiltersChange = useCallback(
    (
      filters: Partial<Omit<PurchaseOrderParamsType, keyof CommonParamsType>>,
    ) => {
      setParams((prev) => ({ ...prev, ...filters, page: 1 }));
    },
    [setParams],
  );

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: PURCHASE_ORDER_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <PurchaseOrderActions
            params={params}
            handleSearch={handleSearch}
            onFilterChange={handleFiltersChange}
          />
          <PurchaseOrderTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default PurchaseOrderWebLayout;
